/**
 * 결과 페이지에서 추천하는 상품·강의 목록.
 * 결과마다 recommend.products 에 아래 id 를 적으면 그 순서대로 보입니다.
 *
 * 강의나 새 상품은 같은 모양으로 추가하세요.
 *   { id: "lecture-xxx", label: "강의", title: "…", desc: "한 줄 설명", url: "https://…" }
 */
export const products = [
  {
    id: "practical-notion",
    label: "템플릿",
    title: "실용적인 기록을 위한 Practical Notion",
    desc: "성향에 맞춰 쓰는 노션 기록 템플릿",
    url: "https://moistnarratives.imweb.me/31/?idx=15",
  },
  {
    id: "writing-site",
    label: "사이트",
    title: "강제 글쓰기 사이트 : 모이스트 망고",
    desc: "미루지 못하게, 일단 쓰게 만드는 곳",
    url: "https://writing.moistmarketer.com/",
  },
  {
    id: "kmong",
    label: "판매",
    title: "단상을 판매하다",
    desc: "촉촉한마케터의 크몽 상품",
    url: "https://kmong.com/@%EC%B4%89%EC%B4%89%ED%95%9C%EB%A7%88%EC%BC%80%ED%84%B0",
  },
  {
    id: "column",
    label: "칼럼",
    title: "각자의 난이도로 살아간다는 것은",
    desc: "비교하지 않고 내 속도로 가는 법",
    url: "https://blog.naver.com/moistmarketer/223225286890",
  },
  {
    id: "moist-note",
    label: "블로그",
    title: "모이스트 노트 (뒷이야기)",
    desc: "테스트와 템플릿을 만든 이야기",
    url: "https://blog.naver.com/moistmarketer/222433371074/",
  },
  {
    id: "book",
    label: "책",
    title: "내 생각과 관점을 수익화하는 퍼스널 브랜딩",
    desc: "촉촉한마케터의 책 · 쿠팡에서 보기",
    url: "https://link.coupang.com/a/ingGm2CIRo",
    coupang: true, // 쿠팡 파트너스 링크 → 결과 아래 고지 문구가 자동으로 붙어요
  },
  {
    id: "book2",
    label: "책",
    title: "능동적 아웃풋",
    desc: "촉촉한마케터의 책 · 쿠팡에서 보기",
    url: "https://link.coupang.com/a/ingHGTGtR6",
    coupang: true,
  },
  {
    id: "about",
    label: "소개",
    title: "제작자 촉촉한마케터 소개",
    desc: "이 테스트를 만든 사람",
    url: "https://blog.naver.com/moistmarketer/222726304393",
  },
  // { id: "lecture-1", label: "강의", title: "강의 이름", desc: "한 줄 설명", url: "https://…" },
];

export const findProducts = (ids = []) =>
  ids.map((id) => products.find((p) => p.id === id)).filter(Boolean);
